import { AppIdentifier, Filters } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED,
  ACTION_SET_FILTERS
} from "./constants";

export interface ICryptoBuyState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
  filters?: Filters
}

export interface ICryptoBuyAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
  filters?: Filters;
}

const INITIAL_STATE: ICryptoBuyState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: ICryptoBuyState, action: ICryptoBuyAction) : ICryptoBuyState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: ICryptoBuyState, action: ICryptoBuyAction) : ICryptoBuyState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: ICryptoBuyState, action: ICryptoBuyAction) : ICryptoBuyState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}

const applySetFilters = (state: ICryptoBuyState, action: ICryptoBuyAction) : ICryptoBuyState => {
  return {
      ...state,
      filters: action.filters,
  }
}

const reducerMap: { [actionType: string]: (state: ICryptoBuyState, action: ICryptoBuyAction) => ICryptoBuyState } = {
  // Crypto buy reducer
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_BUY)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_BUY)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_BUY)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_BUY)}${ACTION_SET_FILTERS}`]: applySetFilters,
};

const cryptoBuyReducer = (state = INITIAL_STATE, action: ICryptoBuyAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default cryptoBuyReducer;
